<template>
  <v-container>
    <v-expansion-panels v-model="panel" multiple>
      <v-expansion-panel class="mb-2">
        <v-expansion-panel-header
          class="primary headline text-left white--text"
        >
          Bill Search
          <template v-slot:actions>
            <v-icon class="white--text">$vuetify.icons.expand</v-icon>
          </template>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <!-- <v-select v-model="year" :items="availableYears" return-object>
            <template v-slot:selection="{ item, index }"
              >{{ item.year }} {{ item.title }}
            </template>
            <template v-slot:item="{ item, index }"
              >{{ item.year }} {{ item.title }}
            </template>
          </v-select> -->
          <LuSession v-model="year" return-object>
            <template v-slot:selection="{ item, index }"
              >{{ item.Year }} {{ item.Title }}
            </template>
            <template v-slot:item="{ item, index }"
              >{{ item.Year }} {{ item.Title }}
            </template>
          </LuSession>
          <v-autocomplete
            :items="billInfo"
            v-model="selected"
            return-object
            :loading="billLoading"
            :search-input.sync="search"
            :filter="billFilter"
            clearable
          >
            <template v-slot:selection="{ item, index }"
              >{{ item.billNum }}: {{ item.shortTitle }}
            </template>
            <template v-slot:item="{ item, index }">
              <v-list-item-content>
                <v-list-item-title
                  >{{ item.billNum }}: {{ item.shortTitle }}</v-list-item-title
                >
                <v-list-item-subtitle
                  ><span :class="`status-${item.billStatus}`">
                    {{ item.lastAction }} | Updated
                    {{ dayjs(item.lastActionDate).fromNow() }}
                  </span>
                  <br />
                  {{ item.sponsor }}
                  <span v-if="item.enrolledNo">
                    | {{ getEnrolledText(item) }}
                    <span v-if="item.chapterNo"> | </span>
                  </span>
                  <span v-if="item.chapterNo">
                    CH{{ item.chapterNo.padStart(4, '0') }}
                  </span>
                </v-list-item-subtitle>
              </v-list-item-content>
            </template>
          </v-autocomplete>
          <div>
            <BillDetails
              :bill="selectedBill"
              :billStub="billStub"
              :loading="itemLoading"
              @refresh="loadSelectedBill(selected)"
              @refreshTrackedBills="searchTrackedBills"
            ></BillDetails>
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-header
          class="primary headline text-left white--text"
        >
          Tracked Bills
          <template v-slot:actions>
            <v-icon class="white--text">$vuetify.icons.expand</v-icon>
          </template>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row class="mt-5">
            <v-col cols="12" xs="12" sm="6" md="3">
              <LuConcern
                class=""
                v-model="searchConcerns"
                small-chips
                dense
                clearable
              ></LuConcern>
            </v-col>
            <v-col cols="12" xs="12" sm="6" md="3">
              <LuPriority
                class=""
                v-model="searchPriorities"
                dense
                clearable
                small-chips
              ></LuPriority>
            </v-col>
            <v-col
              cols="12"
              xs="12"
              sm="6"
              md="3"
              v-if="userViewAgencies.findIndex((a) => a.ID == 2) != -1"
            >
              <LuPosition
                class=""
                v-model="searchPositions"
                dense
                clearable
                small-chips
              ></LuPosition>
            </v-col>
            <!-- <v-col cols="12" xs="12" sm="6" md="3">
              <LuAgency v-model="searchAgencies" clearable></LuAgency>
            </v-col> -->
            <v-col cols="12" xs="12" sm="6" md="3">
              <User
                class=""
                label="Assigned To"
                v-model="searchAssignedTo"
                clearable
                small-chips
              ></User>
            </v-col>
            <v-col cols="12" xs="12" sm="6" md="3">
              <LuAgencyDivision
                class=""
                :items="luAgencyDivisions"
                v-model="searchDivisions"
                label="Division"
                clearable
                showSelectAll
                small-chips
              >
                <!-- <template
                      v-if="divisionAgencies.length > 1"
                      v-slot:selection="data"
                    >
                      <v-chip
                        v-bind="data.attrs"
                        :input-value="data.selected"
                        close
                        small
                        v-if="data.index < 5"
                        @click="data.select"
                        @click:close="searchDivisions.splice(data.index, 1)"
                        >{{ data.item.Agency.Abr }}:
                        {{ data.item.Description }}</v-chip
                      ></template
                    > -->
                <template
                  v-if="divisionAgencies.length > 1"
                  v-slot:item="{ active, item, attrs, on }"
                >
                  <v-list-item v-on="on" v-bind="attrs" #default="{ active }">
                    <v-list-item-action>
                      <v-checkbox :input-value="active"></v-checkbox>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>
                        <v-row no-gutters align="center">
                          {{ item.Description }}
                          <v-spacer></v-spacer>
                          <v-chip
                            v-if="item.Agency"
                            text-color="white"
                            color="primary"
                            small
                            >{{ item.Agency.Abr }}</v-chip
                          >
                        </v-row>
                      </v-list-item-title></v-list-item-content
                    >
                  </v-list-item></template
                >
              </LuAgencyDivision>
            </v-col>
            <v-col cols="12" xs="12" sm="6" md="3">
              <v-select
                class=""
                label="Bill Status"
                v-model="searchBillStatus"
                clearable
                chips
                deletable-chips
                multiple
                dense
                small-chips
                :items="pascalStatus"
              ></v-select>
            </v-col>
            <v-col cols="12" xs="12" sm="6" md="3">
              <v-text-field
                class="pt-0 mt-0"
                v-model="searchText"
                prepend-inner-icon="mdi-magnify"
                label="Search"
                clearable
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="6" md="3">
              <v-select
                class=""
                label="Sort"
                :items="sortOptions"
                v-model="searchSortBy"
                dense
              ></v-select>
            </v-col>
          </v-row>
          <div style="min-height: 4px">
            <v-progress-linear :indeterminate="loading"></v-progress-linear>
          </div>
          <v-data-iterator
            :items="trackedBillsMapped"
            :server-items-length="searchTotal"
            :loading="loading"
            :sort-by.sync="searchSortBy"
            :sort-desc.sync="searchDescending"
            :page.sync="searchPage"
            :items-per-page.sync="searchRowsPerPage"
            :footer-props="{
              itemsPerPageOptions: [5, 10, 25, 50, 100, 500],
            }"
          >
            <template
              v-if="searchRowsPerPage"
              v-slot:header="{ pagination, options, updateOptions }"
            >
              <v-data-footer
                :sort-by.sync="searchSortBy"
                :sort-desc.sync="searchDescending"
                :page.sync="searchPage"
                :items-per-page.sync="searchRowsPerPage"
                :itemsPerPageOptions="[5, 10, 25, 50, 100, 500]"
                :pagination="pagination"
                :options="options"
                @update:options="updateOptions"
              >
                <template v-slot:prepend>
                  <div class="v-data-footer__select flex-grow-1">
                    Selected Page:
                    <v-select
                      hide-details
                      v-model="searchPage"
                      :items="availablePages"
                    ></v-select>
                  </div>
                </template>
              </v-data-footer>
            </template>
            <template v-slot:default="props">
              <div>
                <v-row justify="center" class="mt-3">
                  <v-expansion-panels accordion multiple>
                    <v-expansion-panel
                      v-for="trackedBill in props.items"
                      :key="trackedBill.ID"
                    >
                      <v-expansion-panel-header>
                        <div>
                          <a
                            @click.stop="selectBill(trackedBill)"
                            v-if="
                              trackedBill &&
                              trackedBill.ID &&
                              !trackedBill.IsSummary
                            "
                            :href="`#/bill/${trackedBill.ID}`"
                            >{{ trackedBill.BillNumber }} -
                            {{ trackedBill.ShortTitle }}</a
                          >
                          <span v-else
                            >{{ trackedBill.BillNumber }} -
                            {{ trackedBill.ShortTitle }}
                          </span>
                          <span
                            class="pl-5"
                            v-if="trackedBill && trackedBill.ID"
                            v-for="a in trackedBill.owningAgencies"
                          >
                            <v-chip small label color="primary">{{
                              a.Abr
                            }}</v-chip>
                          </span>
                          <span v-if="trackedBill && trackedBill.ID"
                            ><span
                              class="pl-2"
                              v-for="d in trackedBill.TrackedBillDivisions.filter(
                                (v, i, list) => {
                                  return (
                                    list.findIndex(
                                      (l) => l.DivisionId == v.DivisionId
                                    ) === i
                                  )
                                }
                              )"
                            >
                              <v-chip small outlined color="primary"
                                ><span>
                                  <span
                                    v-if="trackedBill.owningAgencies.length > 1"
                                  >
                                    {{ d.Division.Agency.Abr }}:
                                  </span>
                                  {{ d.Division.Description }}
                                </span>
                              </v-chip>
                            </span>
                          </span>
                        </div>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <Tracker
                          :trackedBill="trackedBill"
                          @refreshTrackedBills="searchTrackedBills"
                        ></Tracker>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-row>
              </div>
            </template>
            <template v-slot:footer.prepend>
              <div class="v-data-footer__select flex-grow-1">
                Selected Page:
                <v-select
                  hide-details
                  v-model="searchPage"
                  :items="availablePages"
                ></v-select>
              </div>
            </template>
          </v-data-iterator>
          <!-- <div v-else-if="itemLoading">
      <v-skeleton-loader
        v-bind="{ class: 'mb-6', boilerplate: true, elevation: 2 }"
        type="card-heading, list-item-two-line,article, actions"
      ></v-skeleton-loader
    ></div> -->
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-container>
</template>
<script>
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
dayjs.extend(relativeTime)
import { get, sync, commit, call } from 'vuex-pathify'
import BillDetails from '@components/lso/BillDetails'
import Tracker from '@components/lso/Tracker'
import LuConcern from '@components/select/multi-id/LuConcern'
import LuPriority from '@components/select/multi-id/LuPriority'
import LuPosition from '@components/select/multi-id/LuPosition'
import LuAgency from '@components/select/multi-id/LuAgency'
import LuAgencyDivision from '@components/select/LuAgencyDivision/LuAgencyDivision-a-multi-id.vue'
import User from '@components/select/a-search-multi-id/User'
import LuSession from '@components/select/LuSession/LuSession-single'
import { authMethods, authComputed } from '@state/helpers'
export default {
  page: {
    title: 'Tracked Bills',
  },
  //model: {
  //	prop: ''
  //},
  props: {},
  components: {
    BillDetails,
    Tracker,
    LuConcern,
    LuPriority,
    LuPosition,
    LuAgency,
    LuAgencyDivision,
    User,
    LuSession,
  },
  filters: {},
  data() {
    return {
      dayjs,
      selected: null,
      search: '',
      basePdfLink: 'https://www.wyoleg.gov/',
      baseBillLink: 'https://www.wyoleg.gov/Legislation/',
      // searchText: '',
      panel: [0, 1],
      sortOptions: ['A-Z', 'Number', 'Date Updated'],
      sortSelected: 'Date Updated',
    }
  },
  created() {
    this.loadBill()
    this.loadBillStatuses()
    this.searchTrackedBills()
    this.loadLuAgencyDivisions()
    // this.loadSharedTrackedBills()
    // this.loadSummaryTrackedBills()
    // this.loadMyTrackedBills()
  },
  computed: {
    ...authComputed,
    ...sync('bills', ['year']),
    ...sync('trackedBill', [
      'searchText',
      'searchConcerns',
      'searchPriorities',
      'searchPositions',
      'searchAssignedTo',
      'searchBillStatus',
      'searchDivisions',
      // 'searchAgencies',
      'searchTotal',
      'searchPage',
      'searchSortBy',
      'searchDescending',
      'searchRowsPerPage',
    ]),
    ...get('bills', ['billInfo', 'selectedBill', 'itemLoading']),
    ...get('luAgencyDivision', ['luAgencyDivisions']),
    billLoading: get('bills/loading'),
    ...get('trackedBill', [
      'loading',
      'saving',
      'billStatuses',
      'trackedBills',
      'trackedBillsPrivate',
      'trackedBillsShared',
      'trackedBillsSummary',
    ]),
    ...get('luSession', ['luSessions']),
    divisionAgencies() {
      return this.luAgencyDivisions
        ?.map((x) => x.Agency)
        .filter((v, i, list) => {
          return list.findIndex((l) => l.ID == v.ID) === i
        })
    },
    availablePages() {
      if (this.searchRowsPerPage) {
        return Array.from(
          { length: Math.ceil(this.searchTotal / this.searchRowsPerPage) },
          (v, i) => i + 1
        )
      } else {
        return []
      }
    },
    // availableYears() {
    //   return this.years
    //     .filter((item) => item.isActive)
    //     .sort((a, b) => b.year - a.year)
    // },
    trackedBillsMapped() {
      // var allTrackedBills = this.trackedBillsShared
      //   .concat(this.trackedBillsPrivate)
      var allTrackedBills = this.trackedBills?.map((item) => {
        var combined = item.Comments.concat(
          item.Links.map((link) => {
            return {
              ...link,
              link: link
                ? link.URL
                  ? link.URL.startsWith('http')
                    ? link.URL
                    : 'http://' + link.URL
                  : ''
                : '',
            }
          })
        )
          .concat(item.Documents)
          .sort((a, b) => new Date(b.CreatedDate) - new Date(a.CreatedDate))
        var recent = combined.length > 0 ? combined[0] : null
        return {
          ...item,
          recent,
        }
      })

      return allTrackedBills
    },
    assignedUsers() {
      let users = []
      let assignedBills = this.trackedBillsShared.filter(
        (b) => b.Assignments && b.Assignments.length > 0
      )
      assignedBills.forEach((b) => {
        b.Assignments.forEach((a) => {
          if (users.findIndex((u) => u.ID == a.ID) == -1) {
            users.push(a)
          }
        })
      })
      let assignedBillsP = this.trackedBillsPrivate.filter(
        (b) => b.Assignments && b.Assignments.length > 0
      )
      assignedBillsP.forEach((b) => {
        b.Assignments.forEach((a) => {
          if (users.findIndex((u) => u.ID == a.ID) == -1) {
            users.push(a)
          }
        })
      })
      return users
    },
    billStub() {
      var selected = this.selected
      if (this.selected) {
        return {
          bill: selected.billNum,
          catchTitle: selected.shortTitle,
          specialSessionValue: selected.specialSessionValue,
          sponsor: selected.sponsor,
          billType: selected.billType,
          billStatus: selected.billStatus,
          effectiveDate: selected.effectiveDate,
          signedDate: selected.signedDate,
          lastAction: selected.lastAction,
          lastActionDate: selected.lastActionDate,
          enrolledNumber: this.getEnrolledText(selected),
          chapter: selected.chapterNo
            ? 'CH' + selected.chapterNo.padStart(4, '0')
            : '',
          year: selected.year,
        }
      } else {
        return null
      }
    },
    pascalStatus() {
      return this.billStatuses.map(
        (x) => x.charAt(0).toUpperCase() + x.slice(1)
      )
    },
  },
  methods: {
    loadLuAgencyDivisions: call(
      'luAgencyDivision/loadLuAgencyDivisionsForUser'
    ),
    ...call('bills', ['loadBill', 'loadSelectedBill']),
    searchTrackedBills: call('trackedBill/bounce'),
    ...call('trackedBill', ['setSelectedTrackedBill', 'loadBillStatuses']),
    billFilter(item, queryText) {
      const searchText = queryText.toLowerCase()
      return (
        item.billNum.toLowerCase().indexOf(searchText) > -1 ||
        item.shortTitle.toLowerCase().indexOf(searchText) > -1 ||
        item.lastAction.toLowerCase().indexOf(searchText) > -1 ||
        item.billStatus.toLowerCase().indexOf(searchText) > -1 ||
        (!!item.enrolledNo
          ? item.enrolledNo.toLowerCase().indexOf(searchText) > -1
          : false) ||
        (!!item.chapterNo
          ? item.chapterNo.toLowerCase().indexOf(searchText) > -1
          : false) ||
        item.sponsor.toLowerCase().indexOf(searchText) > -1
      )
    },

    getEnrolledText(bill) {
      if (!bill || !bill.enrolledNo) return ''
      switch (bill.billType) {
        case 'HB':
          return 'HEA No. ' + bill.enrolledNo.padStart(4, '0')
        case 'HJ':
          return 'HEJR No. ' + bill.enrolledNo.padStart(4, '0')
        case 'SF':
          return 'SEA No. ' + bill.enrolledNo.padStart(4, '0')
        case 'SJ':
          return 'SEJR No. ' + bill.enrolledNo.padStart(4, '0')
        default:
          return ''
      }
    },

    selectBill(bill) {
      this.setSelectedTrackedBill(bill)
      this.$router.push({
        name: 'bill',
        params: { id: bill.ID },
      })
    },
  },
  watch: {
    selected(nval, oval) {
      this.loadSelectedBill(nval)
    },
    luSessions(nval, oval) {
      if (nval && nval.length > 0) {
        if (!this.year?.Year) {
          //find newest entry and select it
          let session = nval
            .slice()
            .sort((a, b) =>
              a.SessionStartDate < b.SessionStartDate ? 1 : -1
            )[0]
          this.year = session
        }
      }
    },
  },
}
</script>
<style>
.status-inactive {
  color: rgb(128, 5, 5);
}
.status-active {
  color: rgb(1, 1, 129);
}
.status-enrolled {
  color: rgb(4, 59, 4);
}
</style>
